import { produce } from "immer";

const initialState = {
    data: null,
};

const ChatTokenReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ADD_CHAT_TOKEN":
            return produce(state, (draft) => {
                draft.data = action.payload;
            });

        case "REMOVE_CHAT_TOKEN":
            return produce(state, (draft) => {
                draft.data = null;
            });

        default:
            return state;
    }
};

export default ChatTokenReducer;
